import { lazy } from 'react';
import { useModal } from 'src/components/modal';

const Component = lazy(() =>
  import('./NavRecentsMoreDrawer').then((module) => ({
    default: module.NavRecentsMoreDrawer,
  })),
);

export const useNavRecentsMoreDrawer = () => {
  const { hideModal, showModal } = useModal(Component);

  return {
    hideNavRecentsMoreDrawer: hideModal,
    showNavRecentsMoreDrawer: (isHidden: boolean) => showModal({ isHidden }),
  };
};
